import { createContext, useContext } from 'react';

export type UpdateNoteParams = {
  applicationId: string;
  notes: string;
};

interface ApplicationContextProps {
  updateNote: (params: UpdateNoteParams) => Promise<void>;
}

export const ApplicationContext = createContext<ApplicationContextProps>({
  updateNote: {} as ApplicationContextProps['updateNote']
});

export const useApplicationContext = () => useContext(ApplicationContext);
